export const getDestinationDataState = (state: Record<string, any>) =>
  state.dataSync.index.destinations;
